import { render, staticRenderFns } from "./MockupSettings.vue?vue&type=template&id=a94706b8&scoped=true"
import script from "./MockupSettings.vue?vue&type=script&lang=js"
export * from "./MockupSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94706b8",
  null
  
)

export default component.exports